import * as API from '@/services/API';

export default {
  get(id) {
    return API.apiClient.get(`/groups/${id}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/groups/${query}`);
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  search(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/groups/search${query}`);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/groups`, data);
    } else {
      return API.apiClient.put(`/groups/${id}`, data);
    }
  },
  async delete(id) {
    return API.apiClient.delete(`/groups/${id}`);
  }
};
